import apiClient from '@/vue/apiClient.js'

const baseUrl = '/settings/application/integrations'

export default {
  async getAll() {
    const response = await apiClient.get(baseUrl)
    return response.data
  },
  async getIntegrationByCode(code) {
    const response = await apiClient.get(baseUrl + '/' + code)
    return response.data
  },
  async save(code, integration) {
    await apiClient.put(baseUrl + '/' + code, { data: integration })
  },
  async connect(code, data) {
    return await apiClient.put(baseUrl + '/' + code, { data, connect: true })
  },
  async performAction(identificationCode, actionCode, data) {
    return await apiClient.put(baseUrl + '/' + identificationCode + '/action/' + actionCode, {
      data,
    })
  },
}
